// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"9e2826e8","418":"17215e4e","668":"fdab29aa"}[chunkId] + ".js";
};